import { render, staticRenderFns } from "./OtherType.vue?vue&type=template&id=4d68453d&"
import script from "./OtherType.vue?vue&type=script&lang=js&"
export * from "./OtherType.vue?vue&type=script&lang=js&"
import style0 from "./OtherType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports